import { SvgFactory } from '../../Svg';

const PlayNextIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='black'>
        <path d='M35.4913 36C35.0638 36 34.7083 35.8563 34.425 35.5688C34.1417 35.2812 34 34.925 34 34.5V13.5C34 13.075 34.1446 12.7188 34.4338 12.4313C34.7229 12.1437 35.0813 12 35.5087 12C35.9363 12 36.2917 12.1437 36.575 12.4313C36.8583 12.7188 37 13.075 37 13.5V34.5C37 34.925 36.8554 35.2812 36.5663 35.5688C36.2771 35.8563 35.9187 36 35.4913 36ZM13.35 34.35C12.85 34.7167 12.3333 34.7542 11.8 34.4625C11.2667 34.1708 11 33.7333 11 33.15V14.85C11 14.2543 11.2667 13.8137 11.8 13.5282C12.3333 13.2427 12.85 13.2833 13.35 13.65L26.5 22.75C26.9667 23.0537 27.2 23.4713 27.2 24.0028C27.2 24.5343 26.9667 24.95 26.5 25.25L13.35 34.35Z' />
    </svg>,
);

export default PlayNextIcon;
